const ProfileCommonJss = {
	title: {
		fontSize:18,
		color:'text.secondary',
		fontWeight:'bold',
		height: 28,
		mb:1,
	},
	dataContentItem: {
		display:'flex',
		fontSize:12,
		justifyContent:'space-between',
		alignItems:'center',
		px:1,
		backgroundColor:"white",
		cursor:'pointer',
		border:'1px solid #ddd',
		borderBottom:'none',
		'&:last-child': {
			borderBottom:'1px solid #ddd',
		},
		name: {
			flex:1,
			cursor:'pointer',
			height:'40px',
			lineHeight:'40px',
		},
		action: {
			textAlign:'right',
			cursor:'pointer',
			'.MuiChip-root': {
				ml:1,
			}
		},
		'.MuiChip-root': {
			width:'24px',
			height:'24px',
			textAlign:'center',
			lineHeight:'24px',
			'.MuiChip-label': {
				px:0,
			}
		},
		'&._child': {
			height:'34px',
			lineHeight:'34px',
			backgroundColor:'#f3f4f5',
		},
		'&._override': {
			'.MuiChip-root': {
				backgroundColor: '#f97125 !important',
				border:'1px solid #f97125 !important',
			},
		},
		'&._active&._override': {
			color: '#f97125 !important',
			borderColor: '#f97125 !important',
			'.MuiChip-root': {
				backgroundColor: '#f97125 !important',
				border:'1px solid #f97125 !important',
			},
		},
		'&._active': {
			backgroundColor: '#c9b7d8',
			borderColor: '#ae93c5',
			borderBottom:'1px solid #ae93c5',
			borderLeftWidth:'2px',
			'.MuiChip-root': {
				backgroundColor:'#ae93c5',
				border:'1px solid #8b65ac',
			},
			'&._override': {
				color: '#f97125 !important'
			}
		},
		'&._parent_active': {
			'.MuiChip-root': {
				backgroundColor:'#ae93c5',
				border:'1px solid #8b65ac',
			}
		},
		'&._child_active': {
			backgroundColor: '#eee9f3',
			borderLeftColor: '#ae93c5',
			'.MuiChip-root': {
				backgroundColor:'#ae93c5',
			}
		},
		'&._deleted': {
			color:'error.main'
		},
	},
	dataGrid: {
		backgroundColor:'#eee',
		display:'flex',
	},
	dataGridItem: {
		px:2,
		py:1,
		flex:1,
		borderRight:'1px dashed #ddd',
		'&:last-child': {
			borderRight:'none',
		}
	},
	dataTop: {
		display:'flex',
		justifyContent:'space-between',
		alignItems:'center',
		mb:1,
	},
	dataContent: {
		overflowY:'auto',
		maxHeight:'75vh',
		minHeight:'150px',
		empty: {
			backgroundColor:'white',
			p:2,
			py:4,
			textAlign:'center',
			fontSize:12,
		}
	},
	actionSection: {
		backgroundColor:'white',
		display:'flex',
		p:1,
		justifyContent:'space-between',
		alignItems:'center',

	},
	dataTitle: {
		fontSize: 16,
		mt:1,
	},
	dataAction: {

	},
	loadingSection: {
		backgroundColor: 'white',
		textAlign:'center',
		py:2,
	},
	iconButtonActive: {
		backgroundColor:'primary.main',
		color:'white',
		"&:hover": {
			backgroundColor:'primary.main',
			color:'white',
		}
	}
}

export function getProfileCommonJss(visualVariant = 'legacy') {
	if (visualVariant !== 'v3') {
		return ProfileCommonJss
	}

	return {
		...ProfileCommonJss,
		title: {
			...ProfileCommonJss.title,
			fontSize: 13,
			fontWeight: 800,
			letterSpacing: '0.12em',
			textTransform: 'uppercase',
			color: '#344054',
			height: 'auto',
			mb: 1.5,
			px: 1,
		},
		dataGrid: {
			...ProfileCommonJss.dataGrid,
			backgroundColor: 'transparent',
			border: '1px solid #EAECF0',
			borderRadius: '24px',
			overflow: 'hidden',
			boxShadow: '0 12px 32px rgba(16,24,40,0.08)',
		},
		dataGridItem: {
			...ProfileCommonJss.dataGridItem,
			backgroundColor: 'rgba(255,255,255,0.78)',
			borderRight: '1px solid #F2F4F7',
		},
		dataTop: {
			...ProfileCommonJss.dataTop,
			px: 1,
			pt: 1,
		},
		dataContentItem: {
			...ProfileCommonJss.dataContentItem,
			backgroundColor: 'rgba(255,255,255,0.92)',
			border: '1px solid #EAECF0',
			color: '#344054',
			px: 1.5,
			transition: 'all 0.2s ease',
			'&:hover': {
				backgroundColor: '#FCFAFF',
				borderColor: '#D6BBFB',
			},
			name: {
				...ProfileCommonJss.dataContentItem.name,
				fontWeight: 500,
				color: '#344054',
			},
			action: {
				...ProfileCommonJss.dataContentItem.action,
				color: '#667085',
				fontWeight: 500,
			},
			'.MuiChip-root': {
				...ProfileCommonJss.dataContentItem['.MuiChip-root'],
				backgroundColor: '#F9F5FF',
				border: '1px solid #D9D6FE',
				color: '#6941C6',
			},
			'&._child': {
				...ProfileCommonJss.dataContentItem['&._child'],
				backgroundColor: '#F8F7FB',
			},
			'&._active': {
				...ProfileCommonJss.dataContentItem['&._active'],
				backgroundColor: '#F4EBFF',
				borderColor: '#B692F6',
				borderBottom: '1px solid #B692F6',
				color: '#53389E',
				'.MuiChip-root': {
					backgroundColor: '#9E77ED',
					border: '1px solid #875BF7',
					color: '#FFFFFF',
				},
			},
			'&._parent_active': {
				...ProfileCommonJss.dataContentItem['&._parent_active'],
				'.MuiChip-root': {
					backgroundColor: '#9E77ED',
					border: '1px solid #875BF7',
					color: '#FFFFFF',
				},
			},
			'&._child_active': {
				...ProfileCommonJss.dataContentItem['&._child_active'],
				backgroundColor: '#FCFAFF',
				borderLeftColor: '#B692F6',
				'.MuiChip-root': {
					backgroundColor: '#B692F6',
					color: '#FFFFFF',
				},
			},
		},
		dataContent: {
			...ProfileCommonJss.dataContent,
			backgroundColor: 'rgba(255,255,255,0.65)',
			maxHeight: '68vh',
			empty: {
				...ProfileCommonJss.dataContent.empty,
				backgroundColor: '#FCFAFF',
				color: '#667085',
			},
		},
		actionSection: {
			...ProfileCommonJss.actionSection,
			backgroundColor: '#FCFAFF',
			borderTop: '1px solid #F2F4F7',
			borderBottom: '1px solid #F2F4F7',
		},
		dataTitle: {
			...ProfileCommonJss.dataTitle,
			fontSize: 15,
			fontWeight: 700,
			color: '#344054',
		},
		loadingSection: {
			...ProfileCommonJss.loadingSection,
			backgroundColor: '#FCFAFF',
		},
		iconButtonActive: {
			...ProfileCommonJss.iconButtonActive,
			backgroundColor: '#7F56D9',
			color: '#FFFFFF',
			'&:hover': {
				backgroundColor: '#6941C6',
				color: '#FFFFFF',
			},
		},
	}
}

export default ProfileCommonJss